"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M12 1.813a5.545 5.545 0 0 1 5.544 5.545 1 1 0 0 1-2 0 3.545 3.545 0 1 0-7.089 0v3.027h7.093v-.002h1.716v.002h1.378c1.003 0 1.818.814 1.818 1.817v8.166a1.82 1.82 0 0 1-1.818 1.819H5.359a1.82 1.82 0 0 1-1.819-1.819v-8.166a1.82 1.82 0 0 1 1.82-1.817h1.095V7.358A5.546 5.546 0 0 1 12 1.813Zm0 11.87a1.805 1.805 0 0 0-.857 3.391v1.54c0 .553.384 1.004.857 1.004s.858-.45.858-1.005v-1.538A1.805 1.805 0 0 0 12 13.684Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};